/**
 * @generated SignedSource<<89c30b2d28851155acb2fb9182c3ecb1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ClipsPanel_meetingRecording$data = {
  readonly clips: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"ClipsPanel_ClipCard_clip">;
  }> | null;
  readonly id: string;
  readonly " $fragmentType": "ClipsPanel_meetingRecording";
};
export type ClipsPanel_meetingRecording$key = {
  readonly " $data"?: ClipsPanel_meetingRecording$data;
  readonly " $fragmentSpreads": FragmentRefs<"ClipsPanel_meetingRecording">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ClipsPanel_meetingRecording",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingRecordingClip",
      "kind": "LinkedField",
      "name": "clips",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ClipsPanel_ClipCard_clip"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MeetingRecording",
  "abstractKey": null
};
})();

(node as any).hash = "68bf775878ac456f49028ff88de15cfd";

export default node;
